<template>
  <button class="numKey" @click="triggerValue">{{value}}</button>
</template>

<script>
  export default {
    name: 'numKey',
    props: ['value','width'],
    methods: {
      triggerValue(value) {
         this.$emit('keyPushed', this.value);
      }
    }
  }
</script>

<style lang="scss">
  .numKey {
    margin: 0rem;
    border: none;
    color: black;
    appearance: none;
    outline: none;
    width: 100%;
    height: 15vh;
    font-size: 1.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.6s ease-out;
    background: rgb(190, 190, 190);
    &:active {
      background: white;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/NumKey.vue